import styled from '@emotion/styled';

const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;

  &:empty {
    display: none;
  }

  > div:not(:only-child) {
    margin-top: 16px;
  }
`;

export default Footer;
